<template>
  <div>
    <list ref="refEquipmentList" sort-by="equipoId" refetch-records-name="equipos"
      key-field="EquipoId" :actions="actions" :filters.sync="filters" :table-columns="tableColumns"
      :table-actions="tableActions" :refetch-records="fetchEquipments" :sort-dir-desc="false" />
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import tiService from '@/services/informationTecnology.service'
import List from '@/components/List.vue'

export default {
  components: {
    List,
  },
  setup() {
    const { fetchEquipments } = tiService()
    const refEquipmentList = ref(null)
    const filters = ref([
      {
        type: 'select',
        name: 'tipoMarcaId',
        label: i18n.t('AppTI.brand.name'),
        value: '',
        options: [],
        domainName: 'tipoMarca',
      },
      {
        type: 'select',
        name: 'tipoEquipoId',
        label: i18n.t('AppTI.equipment.type'),
        value: '',
        options: [],
        domainName: 'tipoEquipo',
      },
    ])
    const tableColumns = [
      {
        key: 'equipoId',
        label: i18n.t('AppTI.columns.id'),
        sortable: true,
        sortKey: 'EquipoId',
      },
      {
        key: 'tipoEquipoMarcaModelo.nombre',
        label: i18n.t('AppTI.model.name'),
        sortable: false,
      },
      {
        key: 'procesador',
        label: i18n.t('AppTI.equipment.cpu'),
        sortable: false,
      },
      {
        key: 'numeroSerie',
        label: i18n.t('AppTI.equipment.serialNumber'),
        sortable: false,
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
        sortable: false,
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Details'),
        aclAction: 'read',
        aclResource: 'MesaAyuda',
        routeName: 'apps-equipment-details',
        params: ['equipoId'],
        icon: 'CodesandboxIcon',
      },
    ])
    const actions = ref([
      {
        label: i18n.t('AppTI.actions.newEquipment'),
        aclAction: 'create',
        aclResource: 'MesaAyuda',
        routeName: 'apps-equipment-add',
        icon: 'PlusCircleIcon',
      },
    ])

    return {
      refEquipmentList,
      filters,
      tableColumns,
      tableActions,
      actions,
      fetchEquipments,
    }
  },
}
</script>
